import { render, staticRenderFns } from "./CartableComponent.vue?vue&type=template&id=c064ec76&"
import script from "./CartableComponent.vue?vue&type=script&lang=js&"
export * from "./CartableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports